import React from 'react';
import { Modal, Typography, Space, Tag, List, Alert } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

const OperationProgressModal = ({
  visible,
  onClose,
  operation,   // 'seedFacven' | 'correctUnified'
  phase,       // e.g. 'download' | 'process' | 'correct'
  results,     // backend result object or null while loading
}) => {
  const getPhaseText = () => {
    if (operation === 'seedFacven') {
      if (phase === 'download') return 'Téléchargement depuis FTP';
      return 'Import / Traitement des données';
    }
    if (operation === 'correctUnified') {
      return 'Correction des enregistrements';
    }
    return 'Opération en cours';
  };

  const getPhaseDescription = () => {
    if (operation === 'seedFacven') {
      if (phase === 'download') {
        return 'Téléchargement du fichier facven.dbf depuis le serveur FTP...';
      }
      return 'Lecture du fichier, création/mise à jour des enregistrements UnifiedFactureAvoir...';
    }
    if (operation === 'correctUnified') {
      return 'Vérification et correction des enregistrements UnifiedFactureAvoir en base de données...';
    }
    return 'Traitement en cours sur le serveur...';
  };

  const isCompleted = !!results;
  const isError = results && results.success === false;

  return (
    <Modal
      title={
        <Space>
          {isCompleted && !isError && <CheckCircleOutlined style={{ color: '#52c41a' }} />}
          {isError && <CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
          {!isCompleted && <LoadingOutlined />}
          <span>
            {operation === 'seedFacven'
              ? 'Import Unified Table (Facven)'
              : 'Corriger UnifiedFactureAvoir'}
          </span>
        </Space>
      }
      open={visible}
      onCancel={isCompleted ? onClose : undefined}
      footer={isCompleted ? null : undefined}
      closable={isCompleted}
      width={600}
      maskClosable={false}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        {/* While running: just text explaining what's happening */}
        {!isCompleted && (
          <div>
            <Text strong>{getPhaseText()}</Text>
            <br />
            <Text type="secondary">{getPhaseDescription()}</Text>
            <br />
            <Text type="secondary">
              Merci de patienter pendant le traitement sur le serveur...
            </Text>
          </div>
        )}

        {/* When finished: show summary from the server */}
        {isCompleted && results && (
          <div>
            {isError ? (
              <Alert
                message="Erreur"
                description={results.message || 'Une erreur est survenue pendant le traitement.'}
                type="error"
                showIcon
              />
            ) : (
              <>
                <Alert
                  message="Opération terminée avec succès"
                  type="success"
                  showIcon
                  style={{ marginBottom: 16 }}
                />

                {operation === 'seedFacven' && (
                  <Space direction="vertical" style={{ width: '100%' }} size="middle">
                    <div>
                      <Text strong>Résumé de l&apos;import :</Text>
                      <List
                        size="small"
                        dataSource={[
                          { label: 'Total traité', value: results.total || 0, color: 'blue' },
                          { label: 'Réussi', value: results.successful || 0, color: 'green' },
                          { label: 'Ignoré', value: results.skipped || 0, color: 'default' },
                          { label: 'Erreurs', value: results.errors || 0, color: 'red' },
                        ]}
                        renderItem={(item) => (
                          <List.Item>
                            <Space>
                              <Text>{item.label}:</Text>
                              <Tag color={item.color}>{item.value}</Tag>
                            </Space>
                          </List.Item>
                        )}
                      />
                    </div>
                  </Space>
                )}

                {operation === 'correctUnified' && (
                  <Space direction="vertical" style={{ width: '100%' }} size="middle">
                    <div>
                      <Text strong>Résumé de la correction :</Text>
                      <List
                        size="small"
                        dataSource={[
                          { label: 'Créés', value: results.created || 0, color: 'green' },
                          { label: 'Corrigés', value: results.fixed || 0, color: 'blue' },
                          { label: 'Erreurs', value: results.errors || 0, color: 'red' },
                        ]}
                        renderItem={(item) => (
                          <List.Item>
                            <Space>
                              <Text>{item.label}:</Text>
                              <Tag color={item.color}>{item.value}</Tag>
                            </Space>
                          </List.Item>
                        )}
                      />
                    </div>
                  </Space>
                )}
              </>
            )}
          </div>
        )}
      </Space>
    </Modal>
  );
};

export default OperationProgressModal;











